import styled from '@emotion/styled';
import PolarisIcon from '@/components/_common/PolarisIcon';

export const IconStyled = styled(PolarisIcon)`
  filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.6));
  color: #ffffff;
`;
